export default {
  subject: 'Título de la notificación',
  notification_time: 'Hora de la notificaci',
  type: 'Tipo de notificación',
  unread: 'No leídas',
  all: 'Todas',
  mark_all_read: 'Marcar todo como leído ({count})',
  notification_content: 'Contenido de la notificación',
  attachment: 'Adjunto',
  view_all: 'Ver todo',
  no_notification: 'Aún no tienes notificaciones.'
}
